"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMO_PARTNERS = exports.VALID_PARTNERS = exports.TRW = exports.LOYAL = exports.CUTTLES = exports.LSFF = exports.COMEDY_CROWD = exports.FOUNDER_INSTITUTE = exports.CENTRAL_MEDIA_GROUP = exports.LINKEDIN_BUSINESS = exports.LINKEDIN_PARTNER = exports.PartnerFlow = exports.PartnerDiscountCode = void 0;
var PartnerDiscountCode;
(function (PartnerDiscountCode) {
    PartnerDiscountCode["PARTNER20"] = "PARTNER20";
    PartnerDiscountCode["LINKEDIN25"] = "LINKEDIN25";
})(PartnerDiscountCode = exports.PartnerDiscountCode || (exports.PartnerDiscountCode = {}));
var PartnerFlow;
(function (PartnerFlow) {
    PartnerFlow[PartnerFlow["Representative"] = 0] = "Representative";
    PartnerFlow[PartnerFlow["Password"] = 1] = "Password";
})(PartnerFlow = exports.PartnerFlow || (exports.PartnerFlow = {}));
exports.LINKEDIN_PARTNER = {
    name: "LinkedIn",
    title: "LinkedIn",
    slug: "linkedin",
    privacyURL: "https://www.linkedin.com/legal/privacy-policy",
    privacyCompany: "LinkedIn",
    flow: PartnerFlow.Representative,
    discountCode: PartnerDiscountCode.LINKEDIN25
};
exports.LINKEDIN_BUSINESS = {
    name: "LinkedInBusiness",
    title: "LinkedIn",
    slug: "lpartner",
    privacyURL: "https://www.linkedin.com/legal/privacy-policy",
    privacyCompany: "LinkedIn",
    flow: PartnerFlow.Representative
};
exports.CENTRAL_MEDIA_GROUP = {
    name: "CMG",
    title: "CMG",
    slug: "cmg",
    privacyURL: "http://www.centralmediagroup.co.uk/privacy-policy",
    privacyCompany: "Central Media Group",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.FOUNDER_INSTITUTE = {
    name: "Founder Institute",
    title: "Founder Institute",
    slug: "fi",
    privacyURL: "https://fi.co/privacy_policy",
    privacyCompany: "Founder Institute",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.COMEDY_CROWD = {
    name: "Comedy Crowd",
    title: "Comedy Crowd",
    slug: "comedycrowd",
    privacyURL: "https://thecomedycrowd.com/privacy/",
    privacyCompany: "Comedy Crowd",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.LSFF = {
    name: "LSFF",
    title: "LSFF",
    slug: "shortfilms",
    privacyURL: "https://shortfilms.org.uk/privacy-policy",
    privacyCompany: "LSFF",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.CUTTLES = {
    name: "Cuttles",
    title: "Cuttles",
    slug: "cuttles",
    privacyURL: "https://www.cuttles.io/privacy-policy",
    privacyCompany: "Cuttles",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.LOYAL = {
    name: "Loyal",
    title: "Loyal",
    slug: "loyal",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.TRW = {
    name: "Tech Ready Women",
    title: "Tech Ready Women",
    slug: "trw",
    privacyURL: "https://www.techreadywomen.academy/pages/privacy-policy",
    privacyCompany: "Tech Ready Women",
    flow: PartnerFlow.Password,
    discountCode: PartnerDiscountCode.PARTNER20
};
exports.VALID_PARTNERS = [
    exports.LINKEDIN_PARTNER,
    exports.CENTRAL_MEDIA_GROUP,
    exports.FOUNDER_INSTITUTE,
    exports.COMEDY_CROWD,
    exports.LSFF,
    exports.LINKEDIN_BUSINESS,
    exports.CUTTLES,
    exports.LOYAL,
    exports.TRW
];
exports.PROMO_PARTNERS = [
    exports.CENTRAL_MEDIA_GROUP,
    exports.FOUNDER_INSTITUTE,
    exports.COMEDY_CROWD,
    exports.LSFF,
    exports.LINKEDIN_PARTNER,
    exports.CUTTLES,
    exports.LOYAL,
    exports.TRW
];
//# sourceMappingURL=partners.js.map